<template>
    <v-container fluid pa-2 dark flat>

		<v-layout justify-space-between align-center mx-5 mt-5>
				<img :src='require("../../assets/static/img/logo-hd-1.webp")' alt="logo" width="150px">	
				<v-btn color="#1f97b9" dark>Cotiza aquí</v-btn>	
		</v-layout>	
		
		<v-layout row wrap class="inner-container2" justify-center mx-5 mt-5 >
			<v-flex xs12  justify-center>
				<v-flex xs12 justify-center class="text-xs-center sobre-text2">
					<div class="sobre-text2-inner inner-container2 white--text">
						<p><strong>¿Nuevos muebles?</strong></p>
						<h2>¿Quieres moverlos de forma simple y segura?</h2>
						<br>
						<p><strong>Pide tu flete mientras disfrutas un café.</strong></p>
						<p><strong> El equipo de DuoApp, con personas que tienen experiencia, son confiables y están certificadas, llevarán tus cosas de forma segura y a tiempo donde tu lo necesitas.</strong></p>
						<br>
						<p><strong><a style="font-size: 25px;font-weight: 400; color: #f31010" href= "https://www.duoapp.cl" >Cotiza aquí</a></strong></p>
						<br>
						<h3 style="font-family: 'Water Brush', cursive;">Disfruta el café</h3>
					</div>
				</v-flex>
			</v-flex>
		</v-layout>
		<br>

<!--tutorial-->
		<v-layout row wrap mx-5 mt-5 pa-3 md12>
			<v-layout row wrap class="inner-container" justify-centermx-5 mt-5>
				<v-flex xs12 justify-center>
					<h3 style="color: #1f97b9; font-size: 30px;">¿Como pido el Flete?</h3>
					<v-divider></v-divider>
				</v-flex>
			</v-layout>
			<v-layout col row wrap ma-5 xs12 md12 justify-space-around>	
				<v-flex class="garantias" xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/refrigerador.webp")' alt="icono refrigerador" width="100px" height="100px"></v-img>
					<br>
					<h3 style="color: #1f97b9; font-size: 28px;">Selecciona los Elementos</h3>
				</v-flex>
				<v-flex class="garantias" xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/direccion.webp")' alt="icono direciones" width="100px" height="100px"></v-img>
					<br>
					<h3 style="color: #1f97b9; font-size: 28px;">Indica las direcciones</h3>						
				</v-flex>
				<v-flex class="garantias" xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/opciones.webp")' alt="icono opciones" width="100px" height="100px"></v-img>
					<br>
					<h3 style="color: #1f97b9; font-size: 28px;">Elije el tipo de servicio que te acomode</h3>
				</v-flex>
				<v-flex class="garantias" xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/ClienteSaltaLigero.webp")' alt="icono cliente feliz" width="100px" height="100px"></v-img>
					<br>
					<h3 style="color: #1f97b9; font-size: 28px;"> Haz la reserva y Listo!!  </h3>
				</v-flex>		
			</v-layout>	
			<br>
		</v-layout>
<!--fin tutorial-->

		<!--inicio Garantias-->
		<v-layout class="landingpage-containerGarantias" row wrap mx-5 mt-5 pa-3 md12>
			<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
				<v-flex xs12 justify-center>
					<h3 style="color: #1f97b9; font-size: 30px;">¿Por qué elegir DuoApp?</h3>
					<v-divider></v-divider>
				</v-flex>
			</v-layout>
			<v-layout col row wrap ma-5 xs12 md12 justify-space-around>
				<v-flex   xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/ayudantesligero.webp")' alt="icono ayudantes" width="100px" height="100px"></v-img>
					<br>
					<h3>EQUIPO</h3>
					<br>
					<h3>Las personas que moverán tus cosas tiene experiencia, son confiables y están certificadas por DuoApp.</h3>
				</v-flex>		
				<v-flex   xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/FechaLanding.webp")' alt="icono fecha" width="100px" height="100px"></v-img>
					<br>
					<h3>PUNTUALIDAD</h3>
					<br>
					<h3>Tendrás el horario de inicio fijo y el proceso será lo mas eficiente posible.</h3>
				</v-flex>
						
				<v-flex   xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/trucks.webp")' alt="icono vehiculos" width="110px" height="100px"></v-img>
					<br>
					<h3>CAPACIDAD</h3>
					<br>
					<h3>Siempre llegarán vehículos con la capacidad adecuada. Y las cosas viajaran de forma segura.</h3>
				</v-flex>

				<v-flex  xs12 sm2 justify-center>
					<v-img :src='require("../../assets/static/img/warrantydelgado.webp")' alt="icono garantias" width="100px" height="100px"></v-img>
					<br>
					<h3>GARANTÍAS</h3>
					<br>
					<h3>El horario y la capacidad de carga están GARANTIZADOS. También contarás con un seguro de reparación en caso de daños.</h3>
				</v-flex>		
			</v-layout>	
		</v-layout>
<!--Fin Garantias-->	

<!--inicio Opiniones-->
		<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
			<v-flex xs12 justify-center>
				<h3 style="color: #1f97b9; font-size: 30px;">Nuestros Clientes dicen</h3>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>

		<v-layout row wrap ma-5 pa-3 justify-center
		:class="{'mx-0': $vuetify.breakpoint.smAndDown, 'mx-5': $vuetify.breakpoint.mdAndUp}">		
			<v-layout ma-5 col row wrap xs12 md12 justify-space-around>			
				<v-flex xs12 md4 justify-center>
					<img :src='require("../../assets/static/img/Opinion1.webp")' alt="imagen de la opinion 1" style="max-heigth: 300px; max-width: 350px;">
				</v-flex>
				<v-flex xs12 md4 justify-center>
					<img :src='require("../../assets/static/img/Opinion2.webp")' alt="imagen de la opinion 2" style="max-heigth: 300px; max-width: 350px;">
				</v-flex>	
				<v-flex xs12 md4 justify-center>
					<img :src='require("../../assets/static/img/Opinion3.webp")' alt="imagen de la opinion 3" style="max-heigth: 300px; max-width: 350px;">
				</v-flex>
			</v-layout>				
		</v-layout>	
<!--fin Opiniones-->
<!--inicio Servicios-->
		<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
			<v-flex xs12 justify-center>
				<h3 style="color: #1f97b9; font-size: 30px;">Agenda en cinco minutos</h3>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
		<v-layout class="landingpage-container text-xs-center" row wrap ma-5 pa-3 justify-center
		:class="{'mx-0': $vuetify.breakpoint.smAndDown, 'mx-5': $vuetify.breakpoint.mdAndUp}">
			<v-flex xs12 md5 justify-center>	
				<div class="Nuestros-servicios-container text-xs-center">
					<img :src='require("../../assets/static/img/ServicioBasico.webp")' alt="icono servicio basico" width="150px">
					<br>
					<h2>Cotiza tu Flete básico</h2>
					<br>
					<v-btn color="#1f97b9" dark href="https://www.duoapp.cl/Express">cotiza tu mudanza aquí!</v-btn> <!--https://www.duoapp.cl/cotizador-mudanza-->
				</div>
			</v-flex>		
			<v-flex xs12 md5 justify-center>	
				<div class="Nuestros-servicios-container text-xs-center">
					<br>
					<img :src='require("../../assets/static/img/ServicioCompleto.webp")' alt="icono servicio completo" width="150px">
					<br>
					<h2>Cotiza tu Flete Completo</h2>
					<br>
					<v-btn color="#1f97b9" dark href="https://www.duoapp.cl/Express">cotiza tu mudanza aquí!</v-btn> <!--https://www.duoapp.cl/cotizador-mudanza-->
				</div>	
			</v-flex>
		</v-layout>	
<!--fin Servicios-->
<!--FAQ-->
		<v-layout col row wrap pa-3 md12>
			<v-layout row wrap class="inner-container" justify-center mx-5>
			<v-flex xs12 justify-center>
				<h1 class="mb-2">Preguntas Frecuentes</h1>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
			<v-layout row wrap class="inner-container" justify-center ma-5 mt-5>
				<v-flex xs12 justify-center>
					<v-expansion-panel>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Tienen Salvoconducto para Mudanzas en Cuarentena?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							SI, cada transportista que esta operando actualmente cuenta con <strong>Salvoconducto para Mudanzas en Cuarentena.</strong>
							<br>
							No obstante, cada cliente debe solicitar en <a href="https://www.comisariavirtual.cl/">https://www.comisariavirtual.cl/</a>
							<br>
							El permiso para mudanzas en Cuarentena lo encuentras como: Salvoconducto individual - Mudanza
							<br>
							<strong>Debe tener en consideración que la duración de este Salvoconducto tendrá una validez de 24 horas si la mudanza
							se efectúa en la misma región y 48 horas si es en otra región.</strong>
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Trabajan en Todo Chile o Fuera de Santiago?</strong></div>
					</template>
					<v-card>
						<v-card-text>

							No, por el momento <strong>solo trabajamos dentro de Santiago</strong> y desde aquí hacia otras regiones.
							<br>
							No realizamos mudanzas desde otras regiones a Santiago.
							<br>
							Siempre debes solicitar el Permiso de Mudanzas en Cuarentena o Salvoconducto de Mudanzas.

						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Con cuanto tiempo de anticipación debo reservar?</strong></div>
					</template>
					<v-card>
						<v-card-text>

							Puedes agendar con <strong>1 días de anticipación en el caso de Mudanzas completas.</strong>
							<br>
							Si necesitas el servicio antes también podemos ayudarte. Realiza la cotización sin reserva, indica que es URGENTE. Nos pondremos en contacto para ayudarte a buscar opciones.
							<br>
							<em>Recuerda que debes enviar la Declaración jurada Mudanzas y solicitar el Salvoconducto Mudanzas.</em>

						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Se puede anular el servicio?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							Si <strong>puedes anular el servicio.</strong> Si anulas antes de 24 horas de anticipación te devolvemos el 100% de lo abonado.
							<br>
							Si anulas con menos de 24 horas puedes reagendar el servicio para una nueva fecha o pierdes el 20% de tu reserva.
							<br>
							Las devoluciones se realizan en un plazo de 24 horas hábiles.
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Tengo garantía por el pago de la reserva?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							Si, el Transportista asignado es responsable de realizar el servicio de manera puntual y eficiente. Esta obligado por contrato a cumplir con el servicio. Si no puede hacerlo buscamos otro Transportista.
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>Puedo Agendar o Reservar un servicio de Elementos que no son domésticos?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							Si, debes cotizar esos servicios a traves del siguiente link : <a href="https://www.duoapp.cl/contacto">https://www.duoapp.cl/contacto</a> 
							<br>
							Los servicios de transporte de elementos que <strong>No son domésticos</strong> están sujetos a evaluación.
							<br>
							Podemos agendar servicios para traslados de otros elementos. No obstante el cotizador online (web o smartphone) solo valoriza <strong>Elementos Domésticos</strong> (Muebles, electrodomésticos, maletas, etc).
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Me aseguran que el vehículo llegará a tiempo?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							SI. En el caso que el Transportista informe un retraso superior a 2 horas según lo agendado, no te preocupes, descontaremos el 5% del valor total del servicio por cada media hora de retraso, a contar de la tercera hora. Siempre te mantendremos informado(a).
							<br>
							En el caso que el Transportista no pueda realizar el servicio o tenga un retraso superior a 2 horas nos haremos cargo de reemplazar el vehículo y puedes elegir entre dos opciones :
							<br>
							1.Esperar un máximo de 4 horas con un 20% de descuento sobre el valor total del servicio
							<br>
							2.Reagendar para otra fecha con un 30% de descuento sobre el valor total del servicio.
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Como puedo saber si el vehículo tiene capacidad Suficiente?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							Si <strong>informaste todos los elementos y de forma correcta,</strong> garantizamos la capacidad del vehículo, de acuerdo a ese detalle. El sistema cálcula el volúmen de acuerdo a tu selección de elementos.
							Si al momento de realizar la mudanza encuentras objetos adicionales, no hay problema en incluirlos, siempre y cuando el vehículo tenga capacidad extra. <strong>El Transportista informará el costo adicional.</strong>
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>¿Que pasa si se daña algún objeto?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							El Transportista procura que eso no ocurra. Pero si eso sucede, el transportista tiene la obligación de financiar la reparación. En Duo te ayudamos.
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

					<v-expansion-panel-content expand-icon="fas fa-chevron-down">
					<template v-slot:header>
						<div><strong>Puedo Trasladar todo tipo de carga?</strong></div>
					</template>
					<v-card>
						<v-card-text>
							Si, excepto animales o personas, vivas o muertas, elementos químicos o residuos peligrosos, escombros, basura, drogas o cualquier cosa que infrinja la ley.
							<br>
							Todas las reservas que se realicen de forma automática están sujetas a evaluación. Aquellos elementos que no son domésticos (muebles, electrodomésticos, etc) <strong>NO TIENEN LAS MISMAS TARIFAS</strong>, por lo tanto deben ser valorizados de forma independiente.
						</v-card-text>
					</v-card>
					</v-expansion-panel-content>

				</v-expansion-panel>
				</v-flex>
			</v-layout>
		</v-layout>

	</v-container>
</template>
<style>
	@import url('https://fonts.googleapis.com/css2?family=Water+Brush&display=swap');
	.sobre-text2{
		background-image: url('../../assets/static/img/FondoLanding.webp');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;
	}
	.sobre-textmobile{
		background-color:#1f97b9;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;
	}
</style>
<script>
	
	import * as firebase from "firebase/app";
	import "firebase/firestore";
	import resize from 'vue-resize-directive';
	
  export default {
	  directives: {
      resize
    },
  
	  data () {
      return {
		windowWidth: 0,
      	mobile: false,
		mantenedores: {

		  },
      }
    },
	methods:{
		
		get_mantenedores(){
			let db = firebase.firestore()
			let self = this
			db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
				if (doc.exists) {
				self.mantenedores = doc.data()
					} else {
					// doc.data() will be undefined in this case
					console.log("No such document!");
					}
			}).catch(function(error) {
				console.log("Error getting document:", error);
			});

		},
    },
	watch: {
    
  },
	async mounted() {
		this.get_mantenedores()
		
	},  
  }
</script>